module.exports = __webpack_public_path__ + "static/media/zipleads.4a480afe.png";